import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TnxLoadListComponentCriteria } from './tnx-load-list-criteria.model';
import { TnxLoadStatus } from './tnx-load-status';
import { URL_BASE } from '../../core/constants';
import { map } from 'rxjs/operators';
import { HttpUtils } from '../../shared/http-utils';
import { TnxLoad } from './tnx-load.model';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import { Observable } from 'rxjs';
import { TnxLoadEvent } from './tnx-load-event.model';
import { TnxMetrics } from './tnx-metrics.model';

export const TNX_LOAD_URI = 'freight-auctions/loads';

@Injectable({
  providedIn: 'root'
})
export class TnxLoadService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public search(page: number, size: number, filters: TnxLoadListComponentCriteria): Observable<SearchObjectResult<TnxLoad>> {
    const { headers, params } = this.prepareSearchRequest({...filters}, page, size);
    const url = `${URL_BASE}/api/${TNX_LOAD_URI}/search`;

    return this.http.get(url, {headers, params})
      .pipe(map(res => SearchObjectResult.fromDto(res, TnxLoad.fromDto)));
  }

  public getMetrics(filters: any): Observable<TnxMetrics> {
    const criteria = this.prepareCriteria({...filters});
    const headers = HttpUtils.createHeaders();
    const params = { ...criteria };
    const url = `${URL_BASE}/api/${TNX_LOAD_URI}/stats`;

    return this.http.get(url, { headers, params })
      .pipe(map(res => TnxMetrics.fromDto(res)));
  }

  public getLoadEvents(loadUuid: string): Observable<TnxLoadEvent[]> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/${TNX_LOAD_URI}/${loadUuid}/events`;

    return this.http.get(url, { headers })
      .pipe(map((res: any[]) => TnxLoadEvent.fromDtos(res)));
  }

  private prepareSearchRequest(filters: any, page: number, size: number) {
    filters = this.prepareCriteria(filters);

    const headers = HttpUtils.createHeaders();
    const params  = {
      page: String(page - 1),
      size: String(size),
      ...filters
    };
    return { headers, params };
  }

  private prepareCriteria(filters: any) {
    if (!filters.loadIds || filters.loadIds.length === 0) {
      delete filters['loadId'];
    } else {
      filters.loadIds = filters.loadIds.join(',');
    }
    if (!filters.deliveryNumbers || filters.deliveryNumbers.length === 0) {
      delete filters['deliveryNumber'];
    } else {
      filters.deliveryNumbers = filters.deliveryNumbers.join(',');
    }
    if (filters.status === TnxLoadStatus.ALL) {
      delete filters['status'];
    }
    if (!filters.originCountryCode) {
      delete filters['originCountryCode'];
    }
    if (!filters.destinationCountryCode) {
      delete filters['destinationCountryCode'];
    }
    if (!filters.carrier) {
      delete filters.carrier;
    }
    if (!filters.assignmentDeadlineAfter) {
      delete filters['assignmentDeadlineAfter'];
    } else  {
      filters.assignmentDeadlineAfter = filters.assignmentDeadlineAfter.toISOString();
    }
    if (!filters.assignmentDeadlineBefore) {
      delete filters['assignmentDeadlineBefore'];
    } else  {
      filters.assignmentDeadlineBefore = filters.assignmentDeadlineBefore.endOf('day').toISOString();
    }
    if (!filters.lastEventAfter) {
      delete filters['lastEventAfter'];
    } else  {
      filters.lastEventAfter = filters.lastEventAfter.toISOString();
    }
    if (!filters.lastEventBefore) {
      delete filters['lastEventBefore'];
    } else  {
      filters.lastEventBefore = filters.lastEventBefore.endOf('day').toISOString();
    }
    return filters;
  }
}
